module.exports = __webpack_public_path__ + "0d5d626b9764ad7a82d39c7305b5ba68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/04_TARA_PRI_02.png
// module id = 104
// module chunks = 0